

// Strips the file extension from a filename.
export function getFileBaseName(fileName: string) {
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex <= 0) return fileName;
  return fileName.slice(0, lastDotIndex);
}